import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { ProfileCard } from '../../components/profile/ProfileCard';
import { ProfileApi } from '../../api/profile/ProfileApi';

export class ProfilePage extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.ProfilePage.Background,
      rect: true,
      Title: {
        x: w => w / 2,
        y: 300,
        mountX: 0.5,
        text: {
          ...Theme.Fonts.Default,
          text: 'Profile Page',
          textAlign: 'center',
        },
      },
      ProfileCardContainer: {
        x: 0,
        y: h => h / 2,
        mountY: 0.5,
        w: w => w,
        h: 300,
        flex: {
          direction: 'row',
          justifyContent: 'center',
        },
      },
    };
  }

  _init() {
    this._index = -1;
    this.tag('Title').text.text = this.params.backend.translations.forKey('profile_select_title');
  }

  updateCards() {
    this.tag('ProfileCardContainer').childList.clear();
    ProfileApi.list(this.params.backend).then(result => {
      this._profiles = result;
      result.forEach(item => {
        this.tag('ProfileCardContainer').add({
          type: ProfileCard,
          data: item,
          backend: this.params.backend,
          flexItem: {
            marginLeft: 10,
            marginRight: 10,
          },
        });
      });
      if (result.length < 5) {
        this.tag('ProfileCardContainer').add({
          type: ProfileCard,
          data: undefined,
          backend: this.params.backend,
          flexItem: {
            marginLeft: 10,
            marginRight: 10,
          },
        });
      }
      if (this._index === -1) {
        this._index = 0;
      }
      this._refocus();
    });
  }

  _focus() {
    this.updateCards();
  }

  _getFocused() {
    return this.tag('ProfileCardContainer').children[this._index];
  }

  _handleRight() {
    if (this._index < this.tag('ProfileCardContainer').childList.length - 1) {
      this._index += 1;
      return true;
    }
    return false;
  }

  _handleLeft() {
    if (this._index > 0) {
      this._index -= 1;
      return true;
    }
    return false;
  }

  _handleBack() {
    this.fireAncestors('$closeModal');
  }
}
